import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const images = [
    "../images/studio/Studio-2.png",
    "../images/studio/Studio-5.png",
    "../images/studio/Studio-9.png",
    "../images/studio/Studio-15.png",
    "../images/studio/Studio-22.png",
    "../images/studio/Studio-23.png",
    "../images/studio/Studio-26.png",
    "../images/studio/Studio-35.png",
    "../images/studio/Studio-45.png",
    "../images/studio/Studio-51.png",
    "../images/studio/Studio--2.png",
    "../images/studio/Studio--4.png",
    "../images/studio/Studio--5.png",
    "../images/studio/Studio--6.png",
    "../images/studio/Studio--7.png",
    "../images/studio/Studio--8.png",
    "../images/studio/Studio--9.png",
    "../images/studio/Studio--10.png",
    "../images/studio/Studio--11.png",
    "../images/studio/Studio--12.png",
    "../images/studio/Studio--13.png",
    "../images/studio/Studio--13.png",
    "../images/studio/Studio--15.png",
    "../images/studio/Studio--16.png",
    "../images/studio/Studio--17.png",
    "../images/studio/Studio--18.png",
    "../images/studio/Studio--19.png",
    "../images/studio/Studio--20.png",
    "../images/studio/Studio--21.png",
    "../images/studio/Studio--22.png",
    "../images/studio/Studio--23.png",
    "../images/studio/Studio--24.png",
    "../images/studio/Studio--25.png",
    "../images/studio/Studio--26.png",
    "../images/studio/Studio--27.png",
    "../images/studio/Studio--30.png",
    "../images/studio/Studio--31.png",
    "../images/studio/Studio--32.png",
    "../images/studio/Studio--33.png",
    "../images/studio/Studio--34.png",
    "../images/studio/Studio--35.png",
    "../images/studio/Studio--36.png",
    "../images/studio/Studio--37.png",
    "../images/studio/Studio--73.png",
    "../images/studio/Studio--78.png",
];

function getRandomIndex() {
    return Math.floor(Math.random() * images.length);
}

export default function ImageSlider() {
    const [indices, setIndices] = useState([getRandomIndex(), getRandomIndex(), getRandomIndex()]);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndices([getRandomIndex(), getRandomIndex(), getRandomIndex()]);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container d-flex justify-content-center gap-3">
            {indices.map((index, i) => (
                <motion.img
                    key={i}
                    src={images[index]}
                    alt={`Slide ${index + 1}`}
                    className="img-fluid w-25 h-auto"
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1 }}
                />
            ))}
        </div>
    );
}